import Navigation from "../components/garage/navigation";
export function TermsPage() {
  return (
    <Policy title="Terms and Conditions">
      <p>
        By using My Car Kenya, you agree to use the marketplace lawfully and to
        provide accurate account and listing information.
      </p>
      <p>
        My Car Kenya provides a platform for buyers and sellers. Sellers are
        responsible for the accuracy, availability, pricing and legality of
        their listings. Buyers should independently verify vehicles, parts,
        sellers and transaction terms before paying.
      </p>
      <p>
        Contact requests share the details you submit with the relevant seller.
        We do not guarantee a sale, vehicle condition, delivery or payment
        outcome.
      </p>
    </Policy>
  );
}
export function PrivacyPage() {
  return (
    <Policy title="Privacy Policy">
      <p>
        We collect account, listing and contact-request information needed to
        operate the marketplace, connect buyers with sellers and keep the
        service secure.
      </p>
      <p>
        Seller phone numbers are kept private until a buyer submits a contact
        request. We display seller yard/shop name and location with listings,
        but not their phone number.
      </p>
      <p>
        You may request correction or deletion of your personal information by
        contacting My Car Kenya. We retain records only as needed for service,
        safety, legal and dispute-resolution purposes.
      </p>
    </Policy>
  );
}
function Policy({ title, children }) {
  return (
    <main className="min-h-screen bg-background">
      <Navigation />
      <article className="mx-auto max-w-3xl px-6 py-16">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#c1392a]">
          My Car Kenya
        </p>
        <h1 className="mt-3 font-heading text-4xl font-bold text-dark">
          {title}
        </h1>
        <div className="mt-8 grid gap-5 text-sm leading-7 text-muted">
          {children}
        </div>
      </article>
    </main>
  );
}
